import {IObjectData} from "../../../index";
import {ObjectTypeId} from "../../../constants";
import {getObjectDefinition, IObjectDefinition} from "../../../util/misc";
import {global} from "../../../appContext";
import {nsFa} from "../../fa/fn";
import i = nsFa.i;
import objectHtml from './object.html?raw';

export let template = objectHtml;

interface IParams {
    objectTypeId: ObjectTypeId
    arr: KnockoutObservableArray<string>
}

export class viewModel {
    private objDef: IObjectDefinition;
    private arr: KnockoutObservableArray<string>;

    constructor(params: IParams) {
        this.objDef = getObjectDefinition(params.objectTypeId)!;
        this.arr = params.arr;
    }

    private onPickClick() {
        global.dialogManager.addComponent({
            title: `${i(this.objDef.icon)} ((add)) ((${this.objDef.name}|ac))`,
            content: {
                name: 'component/object/dialog/pick',
                params: {
                    onObjectSelected: (o: IObjectData) => {
                        this.arr.push(String(o.id));
                    },
                    objecttypeid: this.objDef.id,
                    fnValidateRow: (o: IObjectData) => !this.arr().includes(String(o.id)),
                }
            }
        });
    }

}
